// builder-registry.js
import { Builder } from '@builder.io/react';

import test from './test';

Builder.registerComponent(test, {
  name: 'TestComponent',
});